module.exports = __webpack_public_path__ + "assets/img/media-music-layer-48-be7e44d2.png";